import { render, staticRenderFns } from "./ManagementList.vue?vue&type=template&id=33c59d31&scoped=true&"
import script from "./ManagementList.vue?vue&type=script&lang=js&"
export * from "./ManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ManagementList.vue?vue&type=style&index=0&id=33c59d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c59d31",
  null
  
)

export default component.exports